import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "title": _vm.t('日志'),
      "width": 1000,
      "data-sign": "serial_number_log_modal"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-skeleton', {
    attrs: {
      "loading": _vm.loadingStatus,
      "active": ""
    }
  }, [_c('my-table', {
    staticClass: "mt-20",
    attrs: {
      "columns": _vm.columns,
      "bordered": "",
      "data-source": _vm.logTableData,
      "data-sign": "serial_number_log_modal_table"
    }
  })], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };